import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { CookieService } from 'ngx-cookie';
import { Observable } from 'rxjs';
import { CommonService } from "./common.service";
import { ApiService } from "./api.service";

@Injectable()
export class AuthService {

  constructor(private _apiService: ApiService,
    private _localStorageService: LocalStorageService,
    private _cookieService: CookieService,
    private _commonService: CommonService) { }


  login(Username: string, Password: string): Observable<any> {
    let credential: any = {};
    credential.Username = Username;
    credential.Password = Password;

    return this._apiService
      .put('Auth', 'api/security/authenticate', credential)
  }

  forgotPassword(credential: any) {
    return this._apiService
      .put('Auth', 'api/security/ForgotPassword', credential)
  }

  changePassword(credential: any) {
    return this._apiService
      .put('Auth', 'api/user/ResetPassword', credential)
  }

  saveEULAUserResponse(eula: any) {
    return this._apiService
      .post('Auth', 'api/user/SaveEULAUserResponse', eula)
  }

  logout() {
    this._commonService.setUser(null);
    //this._commonService.setCurrentCustomer(null);
    this._localStorageService.clearAll();
    // this._cookieService.remove('selectedFacility');
    // this._cookieService.remove('selectedCustomer');
    this._cookieService.removeAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts